<template>
        <Likert :items="items" :value="singleValue"
                value-key="value"
                label-key="text"
                @input="emitSingleValue($event)"
        ></Likert>
</template>

<script>
  import Likert from "./components/Likert";
  import responseMixin from "./responseMixin";
  export default {
    name: "LikertResponse",
    mixins: [responseMixin],
    components:{
      Likert
    },
    computed: {
      items(){
        return (this.fieldOptions || []).map((opt)=>{
          opt['text']=this.$ta(opt.content_textassetid);
          return opt;
        });
      },

    }
  }
</script>

<style scoped>

</style>